// KontractAI shared constants: status enums, lookup tables, field lists.
//
// All status strings, color mappings, and enumerated lists used throughout
// the app are centralized here. STATUS_COLORS imports the theme tokens so
// adding a new status only requires this file plus an entry in any
// per-component switch statements.

import { T } from "./theme";

export const ALL_STATUSES = [
  "Self-Service Draft",
  "Pending Assignment", "Pending CommOps Assignment", "Pending Legal Assignment",
  "Needs More Information",
  "CommOps Review", "Legal Review", "Internal Review Pending",
  "Counterparty Draft Ready", "Counterparty Review Pending",
  "Approved for Signature", "Pending SignNow Send", "Sent for Signature",
  "Fully Executed", "Cancelled"
];

export const STATUS_COLORS: Record<string, { c: string; b: string }> = {
  "Self-Service Draft": { c: T.cyn, b: T.cynS },
  "Pending Assignment": { c: T.orn, b: T.ornS },
  "Pending CommOps Assignment": { c: T.orn, b: T.ornS },
  "Pending Legal Assignment": { c: T.orn, b: T.ornS },
  "Needs More Information": { c: T.red, b: T.redS },
  "CommOps Review": { c: T.orn, b: T.ornS },
  "Legal Review": { c: T.blu, b: T.bluS },
  "Internal Review Pending": { c: T.orn, b: T.ornS },
  "Counterparty Draft Ready": { c: T.blu, b: T.bluS },
  // "Sent to Client" removed — maps to Counterparty Review Pending
  "Counterparty Review Pending": { c: T.cyn, b: T.cynS },
  "Approved for Signature": { c: T.grn, b: T.grnS },
  // Pending SignNow Send: review-before-send interim state. Operator
  // has clicked Send in KontractAI but still needs to place fields and
  // trigger invites in SignNow's UI. Amber matches other awaiting-
  // external-action statuses (Pending Assignment, CommOps Review).
  "Pending SignNow Send": { c: T.orn, b: T.ornS },
  "Sent for Signature": { c: T.acc, b: T.accS },
  "Fully Executed": { c: T.grn, b: T.grnS },
  "Cancelled": { c: T.txD, b: T.bg3 },
  // Legacy statuses (may exist on old data)
  "Business Review": { c: T.prp, b: T.prpS },
  "Counterparty Review": { c: T.cyn, b: T.cynS },
  "Legal Review Completed": { c: T.grn, b: T.grnS },
  "Partially Executed": { c: T.ylw, b: T.ylwS },
  "Stakeholder Feedback Pending": { c: T.ylw, b: T.ylwS },
  "Client Draft Ready": { c: T.blu, b: T.bluS },
  "Client Review Pending": { c: T.cyn, b: T.cynS },
  "Counterparty Redline Received": { c: T.orn, b: T.ornS },
  "Negotiation Complete": { c: T.grn, b: T.grnS },
};

export const REQUEST_TYPES = ["MSA", "SOW", "NDA", "Vendor Agreement", "Amendment", "Procurement Contract", "Customer Agreement", "DPA", "License Agreement", "Other"];

export const PRIORITIES = ["Normal", "High", "Urgent"];

export const VERSION_LABELS = ["Initial Draft", "Counterparty Draft", "Internal Draft", "Execution Copy"];

export const DEPARTMENTS = ["Engineering", "Sales", "Marketing", "Finance", "Operations", "HR", "Procurement", "R&D"];

export const AI_EXTRACT_FIELDS = [
  "Company Legal Name", "Counterparty Legal Name", "Effective Date", "Termination Date",
  "Contract Type", "Governing Law", "Renewal Clause", "Notice Period", "Payment Terms",
  "Limitation of Liability Summary", "Indemnification Summary", "Confidentiality Term",
  "Assignment Clause", "Termination Rights", "Signature Date"
];

export const AI_UNIVERSAL_FIELDS = ["Company Legal Name", "Counterparty Legal Name", "Effective Date", "Termination Date", "Contract Type", "Governing Law", "Signature Date", "Term", "Affiliate Rights"];

// SignNow parked 2026-06-17; flip to true to unpark. See TECH_DEBT "SignNow integration parked".
export const SIGNNOW_ENABLED = false;
